// extracted by mini-css-extract-plugin
export var borderRadius = "_50-4";
export var large = "_50-3";
export var logoContainer = "_50-0";
export var nameLogo = "_50-2";
export var small = "_50-1";